import React, { useRef } from "react";
import { shallowEqual } from "react-redux";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import IconRain from "../../../../../../../assets/toyota/svg/aem/winterwheels-rain.svg";
import IconVolumeUp from "../../../../../../../assets/toyota/svg/aem/winterwheels-volume-up.svg";
import { type BuildAndBuyLabelType, BnbLabel } from "../../../utils/labels";
import { formatPrice } from "../../../../../../common-deprecated/Globalize";
import useWinterWheelsModal from "../../../hooks/customize/winterwheels/useWinterWheelsModal";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { type WinterWheelCategoryType, STUDDED } from "../../../../../../common-deprecated/constants";
import {
    calculateWinterWheelPrice,
    GetColourForEULabel,
    getCorrectWinterWheelCategoryLabel,
    tyreInfoBnbLabelSelector,
} from "../../../utils/typedUtils";
import Price from "../common/price/Price";
import * as Button from "../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Input from "../../../../../../common-deprecated/styles/v2/toyota/components/Input";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import Hr from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Hr";
import * as Styles from "../step-customize/car-hero/styles/WinterWheels";
import type { WinterWheelsModalType } from "../../../utils/modalConstants";
import { EcoBadge } from "../../../../../../common-deprecated/styles/v2/toyota/components/EcoLabel";
import Popover from "../../../../../../common-deprecated/components/popover/aem/Popover";
import type { ModalViewType, WinterWheelType } from "../../../../../../common-deprecated/types/CommonTypes";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import ImageFluid from "../../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import * as Text from "../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { showPrice } from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsCommon";
import { useCommonLabel } from "../../../../../../common-deprecated/utils/commonLabels";
import { getCarDBAssetSrcSet } from "../../../../../shared-logic/utils/imageUtils";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { useDispatch } from "../../../../../../shared-logic/redux/store";
import { MODAL_DETAILED_TYRE_INFO } from "../../../../../../shared-logic/utils/tyreInfoContants";

type WinterWheelsCategoryPropsType = {
    wheelType: WinterWheelCategoryType;
    winterWheels: WinterWheelType[];
    selectedWinterWheel: WinterWheelType | null;
    selectWinterWheel: (winterWheel: WinterWheelType) => void;
};

const WinterWheelsCategory = (props: WinterWheelsCategoryPropsType): JSX.Element => {
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const tyreInfoLabels = useBnbSelector(tyreInfoBnbLabelSelector, shallowEqual);
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const { wheelType, winterWheels, selectedWinterWheel, selectWinterWheel } = props;

    return (
        <Flex.Row my={{ _: 3 }}>
            {winterWheels
                .filter((wheel) => wheel.wheelCategory === wheelType)
                .map((wheel) => (
                    // WinterWheelCard
                    <Flex.Col width={{ xs: 1, sm: 1 / 2, lg: 1 / 3 }} mb={4} key={wheel.id}>
                        <Styles.Card>
                            <Flex.Row>
                                <Flex.Col width={{ _: 1 }} display="flex" justifyContent="center">
                                    <ImageFluid
                                        {...getCarDBAssetSrcSet(
                                            commonSettings,
                                            [{ width: 450, height: 450 }],
                                            wheel.image,
                                        )}
                                        width="180"
                                        height="180"
                                        sizes="180px"
                                        loading="lazy"
                                        alt={`${wheel.name}`}
                                    />
                                </Flex.Col>
                            </Flex.Row>

                            {wheel.wheelCategory !== STUDDED && wheel.euLabelProperties && (
                                <Flex.Row>
                                    <Flex.Col width={1} my={2} display="flex" justifyContent="center">
                                        <IconWrapper size="xl" mt="-3px">
                                            <Icon variant="close" />
                                        </IconWrapper>
                                        <EcoBadge
                                            backgroundColor={GetColourForEULabel(
                                                wheel.euLabelProperties.fuelEfficiency,
                                            )}
                                        >
                                            {wheel.euLabelProperties.fuelEfficiency}
                                        </EcoBadge>

                                        <IconRain />
                                        <EcoBadge
                                            backgroundColor={GetColourForEULabel(wheel.euLabelProperties.wetGrip)}
                                        >
                                            {wheel.euLabelProperties.wetGrip}
                                        </EcoBadge>
                                        <IconVolumeUp />
                                        <EcoBadge backgroundColor={GetColourForEULabel(wheel.euLabelProperties.noise)}>
                                            {wheel.euLabelProperties.noise}
                                        </EcoBadge>
                                    </Flex.Col>
                                </Flex.Row>
                            )}

                            <Styles.CategoryName>
                                {wheel.name}
                                {wheel.description && <Popover showOnClick content={wheel.description} />}
                            </Styles.CategoryName>
                            <Price price={wheel.price} financeItemId={wheel.id} />
                            <Styles.CategoryDescription>
                                <div>
                                    <BnbLabel label="winterWheelsModalTyreSize" />
                                    {wheel.setProperties}
                                </div>
                                <div>
                                    <BnbLabel label="winterWheelsModalPartNumber" />
                                    {wheel.setPartNumber}
                                </div>
                            </Styles.CategoryDescription>
                            {wheel.tyre && !!tyreInfoLabels && (
                                <Flex.Row>
                                    <Flex.Col display="flex">
                                        <Button.Link
                                            color="grey7"
                                            hasIconRight
                                            onClick={(event) => {
                                                event.preventDefault();
                                                if (wheel.tyre) {
                                                    dispatch(
                                                        showModal({
                                                            type: MODAL_DETAILED_TYRE_INFO,
                                                            tyres: [wheel.tyre],
                                                            tyreInfoLabels,
                                                        }),
                                                    );
                                                }
                                            }}
                                        >
                                            <Text.Button>
                                                <BnbLabel label="tyreInfo" />
                                            </Text.Button>
                                            <IconWrapper>
                                                <Icon variant="info" />
                                            </IconWrapper>
                                        </Button.Link>
                                    </Flex.Col>
                                </Flex.Row>
                            )}

                            <Styles.WheelButtonContainer>
                                <Button.Checkbox
                                    type="button"
                                    onClick={() => selectWinterWheel(wheel)}
                                    selected={!!(selectedWinterWheel && selectedWinterWheel.id === wheel.id)}
                                    aria-pressed={!!(selectedWinterWheel && selectedWinterWheel.id === wheel.id)}
                                >
                                    <IconWrapper>
                                        {selectedWinterWheel && selectedWinterWheel.id === wheel.id ? (
                                            <Icon variant="close" />
                                        ) : (
                                            <Icon variant="plus" />
                                        )}
                                    </IconWrapper>
                                </Button.Checkbox>
                            </Styles.WheelButtonContainer>
                        </Styles.Card>
                    </Flex.Col>
                ))}
        </Flex.Row>
    );
};

const WinterWheelsModal = (props: ModalViewType<WinterWheelsModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const settings = useBnbSelector((state) => state.commonSettings);
    const financeInfo = useBnbSelector((state) => state.finance.info);
    const footerRef = useRef<HTMLDivElement>(null);

    const wheelData = useWinterWheelsModal(close, footerRef, 9, { padding: 0 });
    const { previewImage, cheapestWinterWheel, hasMultipleWheelTypes, wheelType, selectWheelType, wheelCategories } =
        wheelData;
    const { winterWheels, selectedWinterWheel, selectWinterWheel } = wheelData;
    const { includeInstallation, updateInstallationState, totalPrice, confirm, cancel } = wheelData;

    const closeLabel = useCommonLabel("close");

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={cancel} show={show} size="lg">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="winterWheelsModalTitle" />
                </Modal.Title>
                <Modal.Button type="button" aria-label={closeLabel} onClick={close}>
                    <IconWrapper aria-hidden="true">
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>
            <Modal.Body>
                <Styles.Header>
                    <Flex.Row>
                        <Flex.Col width={{ _: 1, sm: 6 / 12, md: 5 / 12 }}>
                            <div>
                                <Type.Text mb={3}>
                                    <BnbLabel label="winterWheelsModalDescription" />
                                </Type.Text>
                            </div>
                            {showPrice(settings) &&
                                (cheapestWinterWheel.price.cash > 0 || cheapestWinterWheel.price.monthly > 0) && (
                                    <Type.Strong>
                                        <Price
                                            price={calculateWinterWheelPrice(cheapestWinterWheel)}
                                            financeItemId={cheapestWinterWheel.id}
                                        />
                                    </Type.Strong>
                                )}
                        </Flex.Col>
                        <Flex.Col width={{ _: 1, sm: 6 / 12, md: 7 / 12 }}>
                            <ImageFluid alt={previewImage.alt} src={previewImage.src} />
                        </Flex.Col>
                    </Flex.Row>
                </Styles.Header>
                <Styles.Content>
                    {/* Category Tabs */}
                    {hasMultipleWheelTypes && (
                        <>
                            <Flex.Row mb={3}>
                                {/* WinterWheelEuLabelLegend */}
                                {wheelType !== STUDDED && (
                                    <Styles.Legend>
                                        <Icon variant="gas" />
                                        <Type.SmallText>
                                            <BnbLabel label="winterWheelsEuLabelFuelEfficiency" />
                                        </Type.SmallText>
                                        <Icon variant="cloudRain" />
                                        <Type.SmallText>
                                            <BnbLabel label="winterWheelsEuLabelWetGrip" />
                                        </Type.SmallText>
                                        <Icon variant="sound" />
                                        <Type.SmallText>
                                            <BnbLabel label="winterWheelsEuLabelNoise" />
                                        </Type.SmallText>
                                    </Styles.Legend>
                                )}
                            </Flex.Row>
                            <Flex.Row mb={5}>
                                <Styles.Categories>
                                    {wheelCategories.map((category) => (
                                        <Styles.Category
                                            key={category}
                                            isActive={wheelType === category}
                                            onClick={() => selectWheelType(category)}
                                        >
                                            <BnbLabel label={getCorrectWinterWheelCategoryLabel(category)} />
                                        </Styles.Category>
                                    ))}
                                </Styles.Categories>
                            </Flex.Row>
                        </>
                    )}

                    <WinterWheelsCategory
                        winterWheels={winterWheels}
                        selectWinterWheel={selectWinterWheel}
                        wheelType={wheelType}
                        selectedWinterWheel={selectedWinterWheel}
                    />

                    {/* WinterWheelInstallation */}
                    <Type.H5 mb={1}>
                        <BnbLabel label="winterWheelsModalInstallationTitle" />
                    </Type.H5>

                    <p>
                        <BnbLabel label="winterWheelsModalInstallationDescription" />
                    </p>

                    <form>
                        <Input.Radio
                            id="winterWheelInstallationYes"
                            checked={includeInstallation}
                            onClick={() => updateInstallationState(true)}
                        >
                            <Input.Label htmlFor="winterWheelInstallationYes">
                                <BnbLabel
                                    label={
                                        `winterWheelsModalInstallationYesText${
                                            selectedWinterWheel.installationCost ? "WithPrice" : ""
                                        }` as BuildAndBuyLabelType
                                    }
                                    params={{
                                        cost:
                                            selectedWinterWheel.installationCost &&
                                            selectedWinterWheel.installationCost.cash
                                                ? formatPrice(
                                                      selectedWinterWheel.installationCost.cash,
                                                      settings.culture.name,
                                                  )
                                                : "",
                                    }}
                                />
                            </Input.Label>
                        </Input.Radio>
                        <Input.Radio
                            id="winterWheelInstallationNo"
                            checked={!includeInstallation}
                            onClick={() => updateInstallationState(false)}
                        >
                            <Input.Label htmlFor="winterWheelInstallationNo">
                                <BnbLabel label="winterWheelsModalInstallationNoText" />
                            </Input.Label>
                        </Input.Radio>
                    </form>

                    <BnbLabel label="winterWheelsModalInstallationTyreHotel" />
                    <Hr mt={4} mb={2} />

                    {/* WinterWheelsTotalPrice */}
                    <Flex.Row justifyContent="space-between">
                        <Flex.Col>
                            <Type.H5 mb={1}>
                                <BnbLabel label="winterWheelsModalTotalWinterSetPriceTitle" />
                            </Type.H5>
                            {includeInstallation && !selectedWinterWheel.installationCost && (
                                <Type.SmallText>
                                    <BnbLabel label="winterWheelsModalExcludingInstallationCosts" />
                                </Type.SmallText>
                            )}
                            {includeInstallation && selectedWinterWheel.installationCost && (
                                <Type.SmallText>
                                    <BnbLabel label="winterWheelsModalIncludingInstallationCosts" />
                                </Type.SmallText>
                            )}
                        </Flex.Col>
                        <Flex.Col textAlign="right">
                            <Type.H5 mb={1}>
                                <Price price={totalPrice} financeInfo={financeInfo} />
                            </Type.H5>
                        </Flex.Col>
                    </Flex.Row>

                    {/* Button Footer */}
                    <Styles.FooterActions ref={footerRef}>
                        <Button.Primary onClick={confirm} m={0}>
                            <Text.Button>
                                <BnbLabel label="winterWheelsModalConfirmSetButton" />
                            </Text.Button>
                        </Button.Primary>
                        <Button.Secondary onClick={cancel} dark m={0}>
                            <Text.Button>
                                <BnbLabel label="winterWheelsModalCancelSetButton" />
                            </Text.Button>
                        </Button.Secondary>
                    </Styles.FooterActions>
                </Styles.Content>
            </Modal.Body>
        </ModalBaseView>
    );
};

export default WinterWheelsModal;
